(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/footer/views/footer-item.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/footer/views/footer-item.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.footer.views.FooterItem = Backbone.Marionette.View.extend({
    className: 'product-start-page-footer-item',
    template: function(data) {
      return svs.app.product_start_page.templates.footer_item(data);
    },
    ui: {
      button: '.js-default-footer-button'
    },
    events: {
      'click @ui.button': 'buttonClick'
    },
    initialize: function() {
      var numberOfFooterItems = this.options.numberOfFooterItems;

      if (numberOfFooterItems === 1) {
        this.$el.addClass('col-xs-12');
      } else if (numberOfFooterItems === 2) {
        this.$el.addClass('col-xs-12 col-md-6');
      } else if (numberOfFooterItems === 3) {
        this.$el.addClass('col-xs-12 col-md-4');
      } else if (numberOfFooterItems === 4) {
        this.$el.addClass('col-xs-12 col-md-3');
      } else if (numberOfFooterItems === 5) {
        this.$el.addClass('col-xs-12 col-md-2');
      }
    },
    buttonClick: function(e) {
      if (this.model.get('callback')) {
        this.model.get('callback')(e, this.model.get('url'));
      }
    }
  });
})(Backbone, _, svs);

 })(window);